import { Config } from '../interfaces';
import { PoolType } from '../services/NostraPoolsSor';

const config: Config = {
  cdpManager: '0x073f6addc9339de9822cab4dac8c9431779c09077f02ba7bc36904ea342dd9eb',
  oracle: '0x0683852789848dea686fcfb66aaebf6477d83b25d8894aae73b15ff19b765bf0',
  interestRateModel: '0x059a943ca214c10234b9a3b61c558ac20c005127d183b86a99a8f3c60a08b4ff',
  deferredBatchCallAdapter: '0x06bde9f5dad56196ce852c8099db62d0a2827bd389cd0d0885aa7c7dd969fd57',
  nstSTRK: '0x04619e9ce4109590219c5263787050726be63382148538f3f936c22aa87d2fc2',
  assets: {
    WBTC: {
      ticker: 'WBTC',
      address: '0x03fe2b97c1fd336e750087d68b9b867997fd64a2661ff3ca5a7c771641e8e7ac',
      oracleAddress: '0x05a039ff36caf644c6f736c4afb82a7076904a99da4e3ff0a7da57b4017f8d39',
      nostraInterestBearingTokenAddress: '0x0735d0f09a4e8bf8a17005fa35061b5957dcaa56889fc75df9e94530ff6991ea',
      nostraInterestBearingCollateralTokenAddress: '0x05b7d301fa769274f20e89222169c0fad4d846c366440afc160aafadd6f88f0c',
      nostraTokenAddress: '0x073132577e25b06937c64787089600886ede6202d085e6340242a5a32902e23e',
      nostraCollateralTokenAddress: '0x036b68238f3a90639d062669fdec08c4d0bdd09826b1b6d24ef49de6d8141eaa',
      debtTokenAddress: '0x0491480f21299223b9ce770f23a2c383437f9fbf57abc2ac952e9af8cdb12c97',
      nostraInterestBearingTokenSymbol: 'iWBTC',
      nostraInterestBearingCollateralTokenSymbol: 'iWBTC-c',
      nostraTokenSymbol: 'nWBTC',
      nostraCollateralTokenSymbol: 'nWBTC-c',
      debtTokenSymbol: 'dWBTC',
      tokenPrecision: 8,
      uiTokenPrecision: 4,
      fiatTokenPrecision: 2,
      assetTier: 'shared',
      pointsBoostFinishTimestamp: 0,
      defiSpringRewards: false,
    },
    ETH: {
      ticker: 'ETH',
      address: '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7',
      oracleAddress: '0x0683852789848dea686fcfb66aaebf6477d83b25d8894aae73b15ff19b765bf0',
      nostraInterestBearingTokenAddress: '0x01fecadfe7cda2487c66291f2970a629be8eecdcb006ba4e71d1428c2b7605c7',
      nostraInterestBearingCollateralTokenAddress: '0x057146f6409deb4c9fa12866915dd952aa07c1eb2752e451d7f3b042086bdeb8',
      nostraTokenAddress: '0x07170f54dd61ae85377f75131359e3f4a12677589bb7ec5d61f362915a5c0982',
      nostraCollateralTokenAddress: '0x044debfe17e4d9a5a1e226dabaf286e72c9cc36abbe71c5b847e669da4503893',
      debtTokenAddress: '0x00ba3037d968790ac486f70acaa9a1cab10cf5843bb85c986624b4d0e5a82e74',
      nostraInterestBearingTokenSymbol: 'iETH',
      nostraInterestBearingCollateralTokenSymbol: 'iETH-c',
      nostraTokenSymbol: 'nETH',
      nostraCollateralTokenSymbol: 'nETH-c',
      debtTokenSymbol: 'dETH',
      tokenPrecision: 18,
      uiTokenPrecision: 4,
      fiatTokenPrecision: 2,
      assetTier: 'shared',
      pointsBoostFinishTimestamp: 0,
      defiSpringRewards: false,
    },
    DAIv0: {
      ticker: 'DAIv0',
      address: '0x00da114221cb83fa859dbdb4c44beeaa0bb37c7537ad5ae66fe5e0efd20e6eb3',
      oracleAddress: '0x0683852789848dea686fcfb66aaebf6477d83b25d8894aae73b15ff19b765bf0',
      nostraInterestBearingTokenAddress: '0x022ccca3a16c9ef0df7d56cbdccd8c4a6f98356dfd11abc61a112483b242db90',
      nostraInterestBearingCollateralTokenAddress: '0x04f18ffc850cdfa223a530d7246d3c6fc12a5969e0aa5d4a88f470f5fe6c46e9',
      nostraTokenAddress: '0x02b5fd690bb9b126e3517f7abfb9db038e6a69a068303d06cf500c49c1388e20',
      nostraCollateralTokenAddress: '0x005c4676bcb21454659479b3cd0129884d914df9c9b922c1c649696d2e058d70',
      debtTokenAddress: '0x066037c083c33330a8460a65e4748ceec275bbf5f28aa71b686cbc0010e12597',
      nostraInterestBearingTokenSymbol: 'iDAI',
      nostraInterestBearingCollateralTokenSymbol: 'iDAI-c',
      nostraTokenSymbol: 'nDAI',
      nostraCollateralTokenSymbol: 'nDAI-c',
      debtTokenSymbol: 'dDAI',
      tokenPrecision: 18,
      uiTokenPrecision: 2,
      fiatTokenPrecision: 4,
      assetTier: 'shared',
      pointsBoostFinishTimestamp: 0,
      defiSpringRewards: false,
      hidden: true,
    },
    DAI: {
      ticker: 'DAI',
      address: '0x05574eb6b8789a91466f902c380d978e472db68170ff82a5b650b95a58ddf4ad',
      oracleAddress: '0x0683852789848dea686fcfb66aaebf6477d83b25d8894aae73b15ff19b765bf0',
      nostraInterestBearingTokenAddress: '0x065bde349f553cf4bdd873e54cd48317eda0542764ebe5ba46984cedd940a5e4',
      nostraInterestBearingCollateralTokenAddress: '0x000215cbd38a1e765cfd2c60bcb291c9d0b0bb7e7f56f682f0d3501303586185',
      nostraTokenAddress: '0x0184dd6328115c2d5f038792e427f3d81d9552e40dd675e013ccbf74ba50b979',
      nostraCollateralTokenAddress: '0x036e722e04ef2ccadb9229b5415272353aaeb9554c989b83d4d932dba8dbe8f9',
      debtTokenAddress: '0x06726ec97bae4e28efa8993a8e0853bd4bad0bd71de44c23a1cd651b026b00e7',
      nostraInterestBearingTokenSymbol: 'iDAI',
      nostraInterestBearingCollateralTokenSymbol: 'iDAI-c',
      nostraTokenSymbol: 'nDAI',
      nostraCollateralTokenSymbol: 'nDAI-c',
      debtTokenSymbol: 'dDAI',
      tokenPrecision: 18,
      uiTokenPrecision: 2,
      fiatTokenPrecision: 4,
      assetTier: 'cross',
      pointsBoostFinishTimestamp: 0,
      defiSpringRewards: false,
    },
    'USDC.e': {
      ticker: 'USDC.e',
      address: '0x053c91253bc9682c04929ca02ed00b3e423f6710d2ee7e0d5ebb06f3ecf368a8',
      oracleAddress: '0x00d8621fa1f45928c462a6db8e78b5a4bb09b6032ba2344707204757cc2adfe3',
      nostraInterestBearingTokenAddress: '0x002fc2d4b41cc1f03d185e6681cbd40cced61915d4891517a042658d61cba3b1',
      nostraInterestBearingCollateralTokenAddress: '0x05dcd26c25d9d8fd9fc860038dcb6e4d835e524eb8a85213a8cda5b7fff845f6',
      nostraTokenAddress: '0x06eda767a143da12f70947192cd13ee0ccc077829002412570a88cd6539c1d85',
      nostraCollateralTokenAddress: '0x05f296e1b9f4cf1ab452c218e72e02a8713cee98921dad2d3b5706235e128ee4',
      debtTokenAddress: '0x063d69ae657bd2f40337c39bf35a870ac27ddf91e6623c2f52529db4c1619a51',
      nostraInterestBearingTokenSymbol: 'iUSDC.e',
      nostraInterestBearingCollateralTokenSymbol: 'iUSDC.e-c',
      nostraTokenSymbol: 'nUSDC.e',
      nostraCollateralTokenSymbol: 'nUSDC.e-c',
      debtTokenSymbol: 'dUSDC.e',
      tokenPrecision: 6,
      uiTokenPrecision: 2,
      fiatTokenPrecision: 4,
      assetTier: 'shared',
      pointsBoostFinishTimestamp: 0,
      defiSpringRewards: false,
    },
    USDT: {
      ticker: 'USDT',
      address: '0x068f5c6a61780768455de69077e07e89787839bf8166decfbf92b645209c0fb8',
      oracleAddress: '0x002bebc40e96b6f2247cc1992d720aed76d9edd7ee9c68cc949deea54defb965',
      nostraInterestBearingTokenAddress: '0x0360f9786a6595137f84f2d6931aaec09ceec476a94a98dcad2bb092c6c06701',
      nostraInterestBearingCollateralTokenAddress: '0x0453c4c996f1047d9370f824d68145bd5e7ce12d00437140ad02181e1d11dc83',
      nostraTokenAddress: '0x06669cb476aa7e6a29c18b59b54f30b8bfcfbb8444f09e7bbb06c10895bf5d7b',
      nostraCollateralTokenAddress: '0x0514bd7ee8c97d4286bd481c54aa0793e43edbfb7e1ab9784c4b30469dcf9313',
      debtTokenAddress: '0x024e9b0d6bc79e111e6872bb1ada2a874c25712cf08dfc5bcf0de008a7cca55f',
      nostraInterestBearingTokenSymbol: 'iUSDT',
      nostraInterestBearingCollateralTokenSymbol: 'iUSDT-c',
      nostraTokenSymbol: 'nUSDT',
      nostraCollateralTokenSymbol: 'nUSDT-c',
      debtTokenSymbol: 'dUSDT',
      tokenPrecision: 6,
      uiTokenPrecision: 2,
      fiatTokenPrecision: 4,
      assetTier: 'shared',
      pointsBoostFinishTimestamp: 0,
      defiSpringRewards: false,
    },
    wstETH: {
      ticker: 'wstETH',
      address: '0x042b8f0484674ca266ac5d08e4ac6a3fe65bd3129795def2dca5c34ecc5f96d2',
      oracleAddress: '0x016e7a7f6f1c205ab9cbbf8e1c170eb6a88a3f51706be8dfa59fc3f1b20a35d7',
      nostraInterestBearingTokenAddress: '0x00ca44c79a77bcb186f8cdd1a0cd222cc258bebc3bec29a0a020ba20fdca40e9',
      nostraInterestBearingCollateralTokenAddress: '0x009377fdde350e01e0397820ea83ed3b4f05df30bfb8cf8055d62cafa1b2106a',
      nostraTokenAddress: '0x07e2c010c0b381f347926d5a203da0335ef17aefee75a89292ef2b0f94924864',
      nostraCollateralTokenAddress: '0x05eb6de9c7461b3270d029f00046c8a10d27d4f4a4c931a4ea9769c72ef4edbb',
      debtTokenAddress: '0x0348cc417fc877a7868a66510e8e0d0f3f351f5e6b0886a86b652fcb30a3d1fb',
      nostraInterestBearingTokenSymbol: 'iwstETH',
      nostraInterestBearingCollateralTokenSymbol: 'iwstETH-c',
      nostraTokenSymbol: 'nwstETH',
      nostraCollateralTokenSymbol: 'nwstETH-c',
      debtTokenSymbol: 'dwstETH',
      tokenPrecision: 18,
      uiTokenPrecision: 4,
      fiatTokenPrecision: 2,
      assetTier: 'shared',
      pointsBoostFinishTimestamp: 0,
      defiSpringRewards: false,
      hidden: true,
    },
    NSTR: {
      ticker: 'NSTR',
      address: '0x00c530f2c0aa4c16a0806365b0898499fba372e5df7a7172dc6fe9ba777e8007',
      oracleAddress: '0x0683852789848dea686fcfb66aaebf6477d83b25d8894aae73b15ff19b765bf0',
      nostraInterestBearingTokenAddress: '0x02589fc11f60f21af6a1dda3aeb7a44305c552928af122f2834d1c3b1a7aa626',
      nostraInterestBearingCollateralTokenAddress: '0x046ab56ec0c6a6d42384251c97e9331aa75eb693e05ed8823e2df4de5713e9a4',
      nostraTokenAddress: '0x02b674ffda238279de5550d6f996bf717228d316555f07a77ef0a082d925b782',
      nostraCollateralTokenAddress: '0x06f8ad459c712873993e9ffb9013a469248343c3d361e4d91a8cac6f98575834',
      debtTokenAddress: '0x03e0576565c1b51fcac3b402eb002447f21e97abb5da7011c0a2e0b465136814',
      nostraInterestBearingTokenSymbol: 'iNSTR',
      nostraInterestBearingCollateralTokenSymbol: 'iNSTR-c',
      nostraTokenSymbol: 'nNSTR',
      nostraCollateralTokenSymbol: 'nNSTR-c',
      debtTokenSymbol: 'dNSTR',
      tokenPrecision: 18,
      uiTokenPrecision: 2,
      fiatTokenPrecision: 4,
      assetTier: 'shared',
      pointsBoostFinishTimestamp: new Date('2024-07-20T00:00:00Z').getTime(),
      defiSpringRewards: false,
    },
    STRK: {
      ticker: 'STRK',
      address: '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d',
      oracleAddress: '0x04b64b2f861d2ac56cee58a02d8474d83dc16cc84ecd8d3ef2024f70aed92378',
      nostraInterestBearingTokenAddress: '0x026c5994c2462770bbf940552c5824fb0e0920e2a8a5ce1180042da1b3e489db',
      nostraInterestBearingCollateralTokenAddress: '0x07c2e1e733f28daa23e78be3a4f6c724c0ab06af65f6a95b5e0545215f1abc1b',
      nostraTokenAddress: '0x07c535ddb7bf3d3cb7c033bd1a4c3aac02927a4832da795606c0f3dbbc6efd17',
      nostraCollateralTokenAddress: '0x040f5a6b7a6d3c472c12ca31ae6250b462c6d35bbdae17bd52f6c6ca065e30cf',
      debtTokenAddress: '0x001258eae3eae5002125bebf062d611a772e8aea3a1879b64a19f363ebd00947',
      nostraInterestBearingTokenSymbol: 'iSTRK',
      nostraInterestBearingCollateralTokenSymbol: 'iSTRK-c',
      nostraTokenSymbol: 'nSTRK',
      nostraCollateralTokenSymbol: 'nSTRK-c',
      debtTokenSymbol: 'dSTRK',
      tokenPrecision: 18,
      uiTokenPrecision: 2,
      fiatTokenPrecision: 4,
      assetTier: 'shared',
      pointsBoostFinishTimestamp: new Date('2024-03-07T00:00:00Z').getTime(),
      defiSpringRewards: false,
    },
    nstSTRK: {
      ticker: 'nstSTRK',
      address: '0x04619e9ce4109590219c5263787050726be63382148538f3f936c22aa87d2fc2',
      oracleAddress: '0x7a6c5abf10b3db404522b292410262510727c3545c4edbd849ca27d602756db',
      nostraInterestBearingTokenAddress: '0x078a40c85846e3303bf7982289ca7def68297d4b609d5f588208ac553cff3a18',
      nostraInterestBearingCollateralTokenAddress: '0x067a34ff63ec38d0ccb2817c6d3f01e8b0c4792c77845feb43571092dcf5ebb5',
      nostraTokenAddress: '0x04b11c750ae92c13fdcbe514f9c47ba6f8266c81014501baa8346d3b8ba55342',
      nostraCollateralTokenAddress: '0x0142af5b6c97f02cac9c91be1ea9895d855c5842825cb2180673796e54d73dc5',
      debtTokenAddress: '0x0292be6baee291a148006db984f200dbdb34b12fb2136c70bfe88649c12d934b',
      nostraInterestBearingTokenSymbol: 'instSTRK',
      nostraInterestBearingCollateralTokenSymbol: 'instSTRK-c',
      nostraTokenSymbol: 'nnstSTRK',
      nostraCollateralTokenSymbol: 'nnstSTRK-c',
      debtTokenSymbol: 'dnstSTRK',
      tokenPrecision: 18,
      uiTokenPrecision: 2,
      fiatTokenPrecision: 4,
      assetTier: 'shared',
      pointsBoostFinishTimestamp: new Date('2024-05-02T00:00:00Z').getTime(),
      defiSpringRewards: false,
      hidden: true,
    },
    xSTRK: {
      ticker: 'xSTRK',
      address: '0x028d709c875c0ceac3dce7065bec5328186dc89fe254527084d1689910954b0a',
      oracleAddress: '0x00710d82c1d0f49738b1ead7d4823a98385230c5a6ecacf16137f1bedaa430d5',
      nostraInterestBearingTokenAddress: '0x04d1125a716f547a0b69413c0098e811da3b799d173429c95da4290a00c139f7',
      nostraInterestBearingCollateralTokenAddress: '0x0257afe480da9255a026127cd3a295a580ef316b297a69be22b89729ae8c1d2a',
      nostraTokenAddress: '0x06878fd475d5cea090934d690ecbe4ad78503124e4f80380a2e45eb417aafb9c',
      nostraCollateralTokenAddress: '0x01b8d8e31f9dd1bde7dc878dd871225504837c78c40ff01cbf03a255e2154bf0',
      debtTokenAddress: '0x0424638c9060d08b4820aabbb28347fc7234e2b7aadab58ad0f101e2412ea42d',
      nostraInterestBearingTokenSymbol: 'ixSTRK',
      nostraInterestBearingCollateralTokenSymbol: 'ixSTRK-c',
      nostraTokenSymbol: 'nxSTRK',
      nostraCollateralTokenSymbol: 'nxSTRK-c',
      debtTokenSymbol: 'dxSTRK',
      tokenPrecision: 18,
      uiTokenPrecision: 2,
      fiatTokenPrecision: 4,
      assetTier: 'shared',
      pointsBoostFinishTimestamp: 0,
      defiSpringRewards: false,
      hidden: true,
    },
    sSTRK: {
      ticker: 'sSTRK',
      address: '0x0356f304b154d29d2a8fe22f1cb9107a9b564a733cf6b4cc47fd121ac1af90c9',
      oracleAddress: '0x049c5edb1394f6d5df7951f42bd1ab267d97faab64421745a14b7d0213a09ace',
      nostraInterestBearingTokenAddress: '0x024fbb2888e04b47f1bc1f3232528dcfc1ddf69d150b19241628e6d42b3545c6',
      nostraInterestBearingCollateralTokenAddress: '0x01fb33831f458b0786e1a041ac2e9df7603635a7caa88aa4ed30c23a787d4e3a',
      nostraTokenAddress: '0x0271f97bd18cdb2e7aff148db683be36891b0dbbffcd42024237a849ef7ad6cd',
      nostraCollateralTokenAddress: '0x01dd8cab616528ba64689a2b7f10bad1acd6bb4e2de3f4f5dab1839f7a89a82e',
      debtTokenAddress: '0x004349ca3d519e1b1da9da5da3cf19e2039b1776a9fe98c529f95ead7964fe0d',
      nostraInterestBearingTokenSymbol: 'isSTRK',
      nostraInterestBearingCollateralTokenSymbol: 'isSTRK-c',
      nostraTokenSymbol: 'nsSTRK',
      nostraCollateralTokenSymbol: 'nsSTRK-c',
      debtTokenSymbol: 'dsSTRK',
      tokenPrecision: 18,
      uiTokenPrecision: 2,
      fiatTokenPrecision: 4,
      assetTier: 'shared',
      pointsBoostFinishTimestamp: 0,
      defiSpringRewards: false,
      hidden: true,
    },
    UNO: {
      ticker: 'UNO',
      address: '0x0719b5092403233201aa822ce928bd4b551d0cdb071a724edd7dc5e5f57b7f34',
      oracleAddress: '0x06661660c8201bf27c5799e819019e6e74914d5e9c6ed1458faeab403fc4b5c1',
      nostraInterestBearingTokenAddress: '0x1325caf7c91ee415b8df721fb952fa88486a0fc250063eafddd5d3c67867ce7',
      nostraInterestBearingCollateralTokenAddress: '0x2a3a9d7bcecc6d3121e3b6180b73c7e8f4c5f81c35a90c8dd457a70a842b723',
      nostraTokenAddress: '0x6757ef9960c5bc711d1ba7f7a3bff44a45ba9e28f2ac0cc63ee957e6cada8ea',
      nostraCollateralTokenAddress: '0x7d717fb27c9856ea10068d864465a2a8f9f669f4f78013967de06149c09b9af',
      debtTokenAddress: '0x4b036839a8769c04144cc47415c64b083a2b26e4a7daa53c07f6042a0d35792',
      nostraInterestBearingTokenSymbol: 'iUNO',
      nostraInterestBearingCollateralTokenSymbol: 'iUNO-c',
      nostraTokenSymbol: 'nUNO',
      nostraCollateralTokenSymbol: 'nUNO-c',
      debtTokenSymbol: 'dUNO',
      tokenPrecision: 18,
      uiTokenPrecision: 2,
      fiatTokenPrecision: 4,
      assetTier: 'shared',
      pointsBoostFinishTimestamp: new Date('2024-05-02T00:00:00Z').getTime(),
      defiSpringRewards: false,
      hidden: true,
    },
    LORDS: {
      ticker: 'LORDS',
      address: '0x0124aeb495b947201f5fac96fd1138e326ad86195b98df6dec9009158a533b49',
      oracleAddress: '0x0683852789848dea686fcfb66aaebf6477d83b25d8894aae73b15ff19b765bf0',
      nostraInterestBearingTokenAddress: '0x0507eb06dd372cb5885d3aaf18b980c41cd3cd4691cfd3a820339a6c0cec2674',
      nostraInterestBearingCollateralTokenAddress: '0x0739760bce37f89b6c1e6b1198bb8dc7166b8cf21509032894f912c9d5de9cbd',
      nostraTokenAddress: '0x000d294e16a8d24c32eed65ea63757adde543d72bad4af3927f4c7c8969ff43d',
      nostraCollateralTokenAddress: '0x02530a305dd3d92aad5cf97e373a3d07577f6c859337fb0444b9e851ee4a2dd4',
      debtTokenAddress: '0x035778d24792bbebcf7651146896df5f787641af9e2a3db06480a637fbc9fff8',
      nostraInterestBearingTokenSymbol: 'iLORDS',
      nostraInterestBearingCollateralTokenSymbol: 'iLORDS-c',
      nostraTokenSymbol: 'nLORDS',
      nostraCollateralTokenSymbol: 'nLORDS-c',
      debtTokenSymbol: 'dLORDS',
      tokenPrecision: 18,
      uiTokenPrecision: 2,
      fiatTokenPrecision: 4,
      assetTier: 'isolated',
      pointsBoostFinishTimestamp: 0,
      defiSpringRewards: false,
      hidden: true,
    },
    EKUBO: {
      ticker: 'EKUBO',
      address: '0x075afe6402ad5a5c20dd25e10ec3b3986acaa647b77e4ae24b0cbc9a54a27a87',
      oracleAddress: '0x04188f18372f0af23d58f830be9bd5f218be2464bc8426d0d6e8bf1713ef591e',
      nostraInterestBearingTokenAddress: '0x006fd4a9efd0c884e0b29506169dd2fcad6b284d5bdbd46ede424abc26d71164',
      nostraInterestBearingCollateralTokenAddress: '0x02360bd006d42c1a17d23ebe7ae246a0764dea4ac86201884514f86754ccc7b8',
      nostraTokenAddress: '0x045863a5605ea7e77f2b043888a9efb1ff6e6b0fb9e62790ff987b2e084ca1f6',
      nostraCollateralTokenAddress: '0x06b1063a4d5c32fef3486bf29d1719eb09481b52d31f7d86a50c64b0b8d5defb',
      debtTokenAddress: '0x073fa792a8ad45303db3651c34176dc419bee98bfe45791ab12f884201a90ae2',
      nostraInterestBearingTokenSymbol: 'iEKUBO',
      nostraInterestBearingCollateralTokenSymbol: 'iEKUBO-c',
      nostraTokenSymbol: 'nEKUBO',
      nostraCollateralTokenSymbol: 'nEKUBO-c',
      debtTokenSymbol: 'dEKUBO',
      tokenPrecision: 18,
      uiTokenPrecision: 2,
      fiatTokenPrecision: 4,
      assetTier: 'shared',
      pointsBoostFinishTimestamp: 0,
      defiSpringRewards: false,
      hidden: true,
    },
  },
  poolsRouter: '0x040784ffdde08057a5957e64ed360c0ae4e04117b6d8e351c6bb912c09c5cbf5',
  pools: {
    'USDC-USDT': {
      pair: {
        id: 'USDC-USDT',
        pointsBoostFinishTimestamp: new Date('2024-02-23T00:00:00Z').getTime(),
        tokenA: {
          ticker: 'USDC.e',
          decimals: 6,
          address: '0x053c91253bc9682c04929ca02ed00b3e423f6710d2ee7e0d5ebb06f3ecf368a8',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'USDT',
          decimals: 6,
          address: '0x068f5c6a61780768455de69077e07e89787839bf8166decfbf92b645209c0fb8',
          uiDecimals: 2,
        },
        address: '0x00c318445d5a5096e2ad086452d5c97f65a9d28cafe343345e0fa70da0841295',
        stable: true,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Stable,
        metaStable: false,
        tags: ['stable'],
      },
    },
    'NSTR-STRK': {
      pair: {
        id: 'NSTR-STRK',
        pointsBoostFinishTimestamp: 0,
        tokenA: {
          ticker: 'NSTR',
          decimals: 18,
          address: '0x00c530f2c0aa4c16a0806365b0898499fba372e5df7a7172dc6fe9ba777e8007',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'STRK',
          decimals: 18,
          address: '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d',
          uiDecimals: 2,
        },
        address: '0x057af3c0e1111f3b2278dd2d3709412af50fa360f9e42b2d27902c0f53e68dc3',
        stable: false,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Weighted,
        metaStable: false,
        tags: ['defi'],
      },
    },
    'nstSTRK-STRK': {
      pair: {
        id: 'nstSTRK-STRK',
        pointsBoostFinishTimestamp: new Date('2024-05-02T00:00:00Z').getTime(),
        tokenA: {
          ticker: 'nstSTRK',
          decimals: 18,
          address: '0x04619e9ce4109590219c5263787050726be63382148538f3f936c22aa87d2fc2',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'STRK',
          decimals: 18,
          address: '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d',
          uiDecimals: 2,
        },
        address: '0x076def79cc9a3a375779c163ad12996f99fbeb4acd68d7041529159bde897160',
        stable: true,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '0x05a2203674d6b3f7b93c88ebf31e2416d43274d3a45143c05bf66171e4407182',
        type: PoolType.Stable,
        metaStable: false,
        swapInNostra: true,
        tags: ['defi'],
        hide: true,
      },
    },
    'STRK-USDC-DEGEN': {
      pair: {
        id: 'STRK-USDC-DEGEN',
        pointsBoostFinishTimestamp: 0,
        tokenA: {
          ticker: 'STRK',
          decimals: 18,
          address: '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'USDC.e',
          decimals: 6,
          address: '0x053c91253bc9682c04929ca02ed00b3e423f6710d2ee7e0d5ebb06f3ecf368a8',
          uiDecimals: 2,
        },
        address: '0x042543c7d220465bd3f8f42314b51f4f3a61d58de3770523b281da61dbf27c8a',
        stable: true,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: true,
        rateProvider: '0x005a5c8a33c15953584898abb0a1b31c1c0fd46a395f0d3dcb32116558fc9992',
        type: PoolType.Stable,
        metaStable: true,
        tags: ['top'],
      },
    },
    'ETH-USDC-DEGEN': {
      pair: {
        id: 'ETH-USDC-DEGEN',
        pointsBoostFinishTimestamp: 0,
        tokenA: {
          ticker: 'ETH',
          decimals: 18,
          address: '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7',
          uiDecimals: 4,
        },
        tokenB: {
          ticker: 'USDC.e',
          decimals: 6,
          address: '0x053c91253bc9682c04929ca02ed00b3e423f6710d2ee7e0d5ebb06f3ecf368a8',
          uiDecimals: 2,
        },
        address: '0x05e03162008d76cf645fe53c6c13a7a5fce745e8991c6ffe94400d60e44c210a',
        stable: true,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: true,
        rateProvider: '0x05a1b2a3cdd0615a706239804e990af3f07b7fb9ba16cef11fac1552059912b9',
        type: PoolType.Stable,
        metaStable: true,
        tags: ['top'],
      },
    },
    'STRK-ETH-DEGEN': {
      pair: {
        id: 'STRK-ETH-DEGEN',
        pointsBoostFinishTimestamp: 0,
        tokenA: {
          ticker: 'STRK',
          decimals: 18,
          address: '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'ETH',
          decimals: 18,
          address: '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7',
          uiDecimals: 4,
        },
        address: '0x01a2de9f2895ac4e6cb80c11ecc07ce8062a4ae883f64cb2b1dc6724b85e897d',
        stable: true,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: true,
        rateProvider: '0x0679b1e3775d800ba7a2c39cb95581cae8abd4d8619cc73038c8772ee38befd4',
        type: PoolType.Stable,
        metaStable: true,
        tags: ['top'],
      },
    },
    'wstETH-ETH': {
      pair: {
        id: 'wstETH-ETH',
        pointsBoostFinishTimestamp: 0,
        tokenA: {
          ticker: 'wstETH',
          decimals: 18,
          address: '0x042b8f0484674ca266ac5d08e4ac6a3fe65bd3129795def2dca5c34ecc5f96d2',
          uiDecimals: 4,
        },
        tokenB: {
          ticker: 'ETH',
          decimals: 18,
          address: '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7',
          uiDecimals: 4,
        },
        address: '0x0577521a1f005bd663d0fa7f37f0dbac4d7f55b98791d280b158346d9551ff2b',
        stable: true,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '0x07fb9e01ab50458032693a7599d92e5a524d2c8bc44e80001090845bf1c0bb1c',
        type: PoolType.Stable,
        metaStable: true,
        tags: ['top'],
      },
    },
    'WBTC-ETH-DEGEN': {
      pair: {
        id: 'WBTC-ETH-DEGEN',
        pointsBoostFinishTimestamp: 0,
        tokenA: {
          ticker: 'WBTC',
          decimals: 8,
          address: '0x03fe2b97c1fd336e750087d68b9b867997fd64a2661ff3ca5a7c771641e8e7ac',
          uiDecimals: 4,
        },
        tokenB: {
          ticker: 'ETH',
          decimals: 18,
          address: '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7',
          uiDecimals: 4,
        },
        address: '0x01583919ffd78e87fa28fdf6b6a805fe3ddf52f754a63721dcd4c258211129a6',
        stable: true,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: true,
        rateProvider: '0x0336f17f689d6472636338d870c11e4bacb33e19f4d86ae3422caefc09636908',
        type: PoolType.Stable,
        metaStable: true,
        tags: ['top'],
      },
    },
    'USDC-DAI': {
      pair: {
        id: 'USDC-DAI',
        pointsBoostFinishTimestamp: 0,
        tokenA: {
          ticker: 'USDC.e',
          decimals: 6,
          address: '0x053c91253bc9682c04929ca02ed00b3e423f6710d2ee7e0d5ebb06f3ecf368a8',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'DAI',
          decimals: 18,
          address: '0x05574eb6b8789a91466f902c380d978e472db68170ff82a5b650b95a58ddf4ad',
          uiDecimals: 2,
        },
        address: '0x0362ec0c49a9c8f2d322d0ba6a8ec1214b9e4f7e80a17d462ec2585362547d95',
        stable: true,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Stable,
        metaStable: false,
        tags: ['stable'],
      },
    },
    'ETH-USDC': {
      pair: {
        id: 'ETH-USDC',
        pointsBoostFinishTimestamp: new Date('2024-02-08T00:00:00Z').getTime(),
        tokenA: {
          ticker: 'ETH',
          decimals: 18,
          address: '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7',
          uiDecimals: 4,
        },
        tokenB: {
          ticker: 'USDC.e',
          decimals: 6,
          address: '0x053c91253bc9682c04929ca02ed00b3e423f6710d2ee7e0d5ebb06f3ecf368a8',
          uiDecimals: 2,
        },
        address: '0x05ef8800d242c5d5e218605d6a10e81449529d4144185f95bf4b8fb669424516',
        stable: false,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Weighted,
        metaStable: false,
        tags: ['top'],
      },
    },
    'WBTC-ETH': {
      pair: {
        id: 'WBTC-ETH',
        pointsBoostFinishTimestamp: new Date('2024-02-08T00:00:00Z').getTime(),
        tokenA: {
          ticker: 'WBTC',
          decimals: 8,
          address: '0x03fe2b97c1fd336e750087d68b9b867997fd64a2661ff3ca5a7c771641e8e7ac',
          uiDecimals: 5,
        },
        tokenB: {
          ticker: 'ETH',
          decimals: 18,
          address: '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7',
          uiDecimals: 4,
        },
        address: '0x0285aa1c4bbeef8a183fb7245f096ddc4c99c6b2fedd1c1af52a634c83842804',
        stable: false,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Weighted,
        metaStable: false,
        tags: ['top'],
      },
    },
    'ETH-USDT': {
      pair: {
        id: 'ETH-USDT',
        pointsBoostFinishTimestamp: new Date('2024-02-08T00:00:00Z').getTime(),
        tokenA: {
          ticker: 'ETH',
          decimals: 18,
          address: '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7',
          uiDecimals: 4,
        },
        tokenB: {
          ticker: 'USDT',
          decimals: 6,
          address: '0x068f5c6a61780768455de69077e07e89787839bf8166decfbf92b645209c0fb8',
          uiDecimals: 2,
        },
        address: '0x052b136b37a7e6ea52ce1647fb5edc64efe23d449fc1561d9994a9f8feaa6753',
        stable: false,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Weighted,
        metaStable: false,
        tags: ['top'],
      },
    },
    'LORDS-ETH': {
      pair: {
        id: 'LORDS-ETH',
        pointsBoostFinishTimestamp: new Date('2024-02-08T00:00:00Z').getTime(),
        tokenA: {
          ticker: 'LORDS',
          decimals: 18,
          address: '0x0124aeb495b947201f5fac96fd1138e326ad86195b98df6dec9009158a533b49',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'ETH',
          decimals: 18,
          address: '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7',
          uiDecimals: 4,
        },
        address: '0x05ae9c593b2bef20a8d69ae7abf1e6da551481f9efd83d03a9f05b6d7c9a78ec',
        stable: false,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Weighted,
        metaStable: false,
        hide: true,
        tags: ['game-fi'],
      },
    },
    'STRK-ETH': {
      pair: {
        id: 'STRK-ETH',
        pointsBoostFinishTimestamp: new Date('2024-03-06T00:00:00Z').getTime(),
        tokenA: {
          ticker: 'STRK',
          decimals: 18,
          address: '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'ETH',
          decimals: 18,
          address: '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7',
          uiDecimals: 4,
        },
        address: '0x068400056dccee818caa7e8a2c305f9a60d255145bac22d6c5c9bf9e2e046b71',
        stable: false,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Weighted,
        metaStable: false,
        tags: ['top'],
      },
    },
    'STRK-USDC': {
      pair: {
        id: 'STRK-USDC',
        pointsBoostFinishTimestamp: new Date('2024-03-06T00:00:00Z').getTime(),
        tokenA: {
          ticker: 'STRK',
          decimals: 18,
          address: '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'USDC.e',
          decimals: 6,
          address: '0x053c91253bc9682c04929ca02ed00b3e423f6710d2ee7e0d5ebb06f3ecf368a8',
          uiDecimals: 2,
        },
        address: '0x07ae43abf704f4981094a4f3457d1abe6b176844f6cdfbb39c0544a635ef56b0',
        stable: false,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Weighted,
        metaStable: false,
        tags: ['top'],
      },
    },
    'NSTR-USDC': {
      pair: {
        id: 'NSTR-USDC',
        pointsBoostFinishTimestamp: new Date('2024-07-17T00:00:00Z').getTime(),
        tokenA: {
          ticker: 'NSTR',
          decimals: 18,
          address: '0x00c530f2c0aa4c16a0806365b0898499fba372e5df7a7172dc6fe9ba777e8007',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'USDC.e',
          decimals: 6,
          address: '0x053c91253bc9682c04929ca02ed00b3e423f6710d2ee7e0d5ebb06f3ecf368a8',
          uiDecimals: 2,
        },
        address: '0x07f232e7857effe04f7351e9bb2f1ebc2589bacca3380ae84efcc22067c1436e',
        stable: false,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Weighted,
        metaStable: false,
        swapInNostra: true,
        tags: ['defi'],
      },
    },
    'zUSDC-USDC': {
      pair: {
        id: 'zUSDC-USDC',
        pointsBoostFinishTimestamp: 0,
        tokenA: {
          ticker: 'zUSDC',
          decimals: 6,
          address: '0x028757d11c97078dd182023b1cc7b9e7659716c631adf94d24f1fa7dc5943072',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'USDC.e',
          decimals: 6,
          address: '0x053c91253bc9682c04929ca02ed00b3e423f6710d2ee7e0d5ebb06f3ecf368a8',
          uiDecimals: 2,
        },
        address: '0x05458b28f32b5f6e635895063ec0fe85c5a3864d257c4ae293edd5f66acf988d',
        stable: true,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Stable,
        metaStable: false,
        hide: true,
        tags: ['stable'],
      },
    },
    'sSTRK-STRK': {
      pair: {
        id: 'sSTRK-STRK',
        pointsBoostFinishTimestamp: 0,
        tokenA: {
          ticker: 'sSTRK',
          decimals: 18,
          address: '0x0356f304b154d29d2a8fe22f1cb9107a9b564a733cf6b4cc47fd121ac1af90c9',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'STRK',
          decimals: 18,
          address: '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d',
          uiDecimals: 2,
        },
        address: '0x010dcf06e1fdc86c68d49a870ab895323e845100fc334b80c70d77c6b37cd6ec',
        stable: true,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Stable,
        metaStable: true,
        hide: true,
        tags: ['defi'],
      },
    },
    'xSTRK-STRK': {
      pair: {
        id: 'xSTRK-STRK',
        pointsBoostFinishTimestamp: 0,
        tokenA: {
          ticker: 'xSTRK',
          decimals: 18,
          address: '0x028d709c875c0ceac3dce7065bec5328186dc89fe254527084d1689910954b0a',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'STRK',
          decimals: 18,
          address: '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d',
          uiDecimals: 2,
        },
        address: '0x00205fd8586f6be6c16f4aa65cc1034ecff96d96481878e55f629cd0cb83e05f',
        stable: true,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Stable,
        metaStable: true,
        hide: true,
        tags: ['defi'],
      },
    },
    'ETH-BRRR': {
      pair: {
        id: 'ETH-BRRR',
        pointsBoostFinishTimestamp: 0,
        tokenA: {
          ticker: 'ETH',
          decimals: 18,
          address: '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7',
          uiDecimals: 4,
        },
        tokenB: {
          ticker: 'BRRR',
          decimals: 18,
          address: '0x067737cbee9be3e3042ca86ef41598af7cc36fa6e109193c165b854de07d1df7',
          uiDecimals: 2,
        },
        address: '0x033c4141c8eb6ab8e7506c6f09c1a64b0995c9a5fa2ba6fa827845535b942786',
        flipDisplayOrder: true,
        stable: false,
        experimental: true,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Weighted,
        metaStable: false,
        swapInNostra: true,
        hide: true,
        tags: ['meme'],
      },
    },
    'STRK-PAL': {
      pair: {
        id: 'STRK-PAL',
        pointsBoostFinishTimestamp: new Date('2024-04-18T00:00:00Z').getTime(),
        tokenA: {
          ticker: 'STRK',
          decimals: 18,
          address: '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'PAL',
          decimals: 18,
          address: '0x049201f03a0f0a9e70e28dcd74cbf44931174dbe3cc4b2ff488898339959e559',
          uiDecimals: 2,
        },
        address: '0x07d24fc0949e9579cb6e08bb65ffe39fd5dd78a47ad2e4eb52e49b97c2cd26db',
        flipDisplayOrder: true,
        stable: false,
        experimental: true,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Weighted,
        metaStable: false,
        swapInNostra: true,
        hide: true,
        tags: ['meme'],
      },
    },
    'STRONK-STRK': {
      pair: {
        id: 'STRONK-STRK',
        pointsBoostFinishTimestamp: new Date('2024-04-18T00:00:00Z').getTime(),
        tokenA: {
          ticker: 'STRONK',
          decimals: 18,
          address: '0x02b2ba5da3a25d7e0d45487649a9c4535f29711b57b9054099737e7c9f7dc10a',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'STRK',
          decimals: 18,
          address: '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d',
          uiDecimals: 2,
        },
        address: '0x013e7962df51aba2afedbc1c86b0b61d36410f97fc75cb8f51e525559bef49f6',
        stable: false,
        experimental: true,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Weighted,
        metaStable: false,
        swapInNostra: true,
        hide: true,
        tags: ['meme'],
      },
    },
    'STRK-TONY': {
      pair: {
        id: 'STRK-TONY',
        pointsBoostFinishTimestamp: new Date('2024-04-18T00:00:00Z').getTime(),
        tokenA: {
          ticker: 'STRK',
          decimals: 18,
          address: '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'TONY',
          decimals: 18,
          address: '0x05f467ace847d1cbc6d1efea978752a8b4549fec043286fec1289d19b8c57e67',
          uiDecimals: 2,
        },
        address: '0x0344653508c3b8831d6826712004f5bcff9d7a9a8fe720ba8e8b6005fb23c04d',
        flipDisplayOrder: true,
        stable: false,
        experimental: true,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Weighted,
        metaStable: false,
        swapInNostra: true,
        hide: true,
        tags: ['meme'],
      },
    },
    'AKU-STRK': {
      pair: {
        id: 'AKU-STRK',
        pointsBoostFinishTimestamp: new Date('2024-04-18T00:00:00Z').getTime(),
        tokenA: {
          ticker: 'AKU',
          decimals: 18,
          address: '0x0137dfca7d96cdd526d13a63176454f35c691f55837497448fad352643cfe4d4',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'STRK',
          decimals: 18,
          address: '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d',
          uiDecimals: 2,
        },
        address: '0x05737b6463e8aab45d9237180ac68515a49fa3e0656f06b5831c15c69af83332',
        stable: false,
        experimental: true,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Weighted,
        metaStable: false,
        swapInNostra: true,
        hide: true,
        tags: ['meme'],
      },
    },
    'ETH-UNO': {
      pair: {
        id: 'ETH-UNO',
        pointsBoostFinishTimestamp: new Date('2024-05-02T00:00:00Z').getTime(),
        tokenA: {
          ticker: 'ETH',
          decimals: 18,
          address: '0x049d36570d4e46f48e99674bd3fcc84644ddd6b96f7c741b1562b82f9e004dc7',
          uiDecimals: 4,
        },
        tokenB: {
          ticker: 'UNO',
          decimals: 18,
          address: '0x0719b5092403233201aa822ce928bd4b551d0cdb071a724edd7dc5e5f57b7f34',
          uiDecimals: 2,
        },
        address: '0x03f8c9062f1bfe45f82cd70ed97ff053bc5836783ec66adfe3288eb1b43aa83b',
        stable: false,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Weighted,
        metaStable: false,
        tags: ['top'],
        hide: true,
        excludeFromSwap: true,
      },
    },
    'STRK-UNO': {
      pair: {
        id: 'STRK-UNO',
        pointsBoostFinishTimestamp: new Date('2024-05-02T00:00:00Z').getTime(),
        tokenA: {
          ticker: 'STRK',
          decimals: 18,
          address: '0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'UNO',
          decimals: 18,
          address: '0x0719b5092403233201aa822ce928bd4b551d0cdb071a724edd7dc5e5f57b7f34',
          uiDecimals: 2,
        },
        address: '0x03d51776d3ce07c211d5dbdf40a9333ec6d6d3a0b2853de1d6706f9ea3b88d45',
        stable: false,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.Weighted,
        metaStable: false,
        tags: ['top'],
        hide: true,
        excludeFromSwap: true,
      },
    },
    'USDC-UNO': {
      pair: {
        id: 'USDC-UNO',
        pointsBoostFinishTimestamp: 0,
        tokenA: {
          ticker: 'USDC.e',
          decimals: 6,
          address: '0x053c91253bc9682c04929ca02ed00b3e423f6710d2ee7e0d5ebb06f3ecf368a8',
          uiDecimals: 2,
        },
        tokenB: {
          ticker: 'UNO',
          decimals: 18,
          address: '0x0719b5092403233201aa822ce928bd4b551d0cdb071a724edd7dc5e5f57b7f34',
          uiDecimals: 2,
        },
        address: '0x07daadaa043b22429020efb9ac16bcc5f6a9b6ed3305de48e65a0ad5dcb76759',
        stable: false,
        experimental: false,
        rewards: false,
        nostraRewards: false,
        degen: false,
        rateProvider: '',
        type: PoolType.ConstantSum,
        metaStable: false,
        hide: true,
        tags: ['stable'],
        excludeFromSwap: true,
      },
    },
  },
};

export { config };
